import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "buttonText"]

  connect() {
    this.updateButtonText()
  }

  toggle() {
    this.updateButtonText()
  }

  updateButtonText() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked)

    if (checkedBoxes.length === 0) {
      this.buttonTextTarget.textContent = "All Stores"
    } else if (checkedBoxes.length === 1) {
      this.buttonTextTarget.textContent = checkedBoxes[0].dataset.store
    } else {
      this.buttonTextTarget.textContent = `${checkedBoxes.length} stores`
    }
  }

  apply() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked)
    const storeNames = checkedBoxes.map(cb => cb.dataset.store)

    // Build URL with current params plus store names
    const url = new URL(window.location.href)
    const currentParams = new URLSearchParams(url.search)

    // Remove existing store params
    currentParams.delete('stores')
    currentParams.delete('stores[]')

    // Add selected stores as array
    if (storeNames.length > 0) {
      storeNames.forEach(store => {
        currentParams.append('stores[]', store)
      })
    }

    // Navigate to new URL
    window.location.href = `${url.pathname}?${currentParams.toString()}`
  }

  reset() {
    // Uncheck all stores
    this.checkboxTargets.forEach(cb => {
      cb.checked = false
    })

    this.updateButtonText()
    this.apply()
  }

  search(event) {
    const searchTerm = event.target.value.toLowerCase()
    const storeItems = this.element.querySelectorAll('[data-store-item]')

    storeItems.forEach(item => {
      const storeName = item.dataset.storeName.toLowerCase()
      if (storeName.includes(searchTerm)) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })
  }
}
